import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { initUserSettings } from "../../actions/userSettingsActions";
import { clearTooManyRequestsBlocking } from "../../utils/localStorageUtils";

export const useInitUserSettings = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        clearTooManyRequestsBlocking();
        dispatch(initUserSettings());
    // eslint-disable-next-line
    }, [])
}